export default "__VITE_ASSET__CqxrucTZ__"